// extracted by mini-css-extract-plugin
module.exports = {"title":"AddToChrome_title__2qXbZ","copy":"AddToChrome_copy__y0PJg","screenshot":"AddToChrome_screenshot__gtAXR","icon":"AddToChrome_icon__3m7FH"};